import React from "react";
import { Typography } from "antd";
import styled, { css } from "styled-components";
import { ColorPalette } from "./color/colorPalette";
interface CustomHintInput {
  customSize?: "XLarge" | "Large";
  status?: "Default" | "Error" | "Warning" | "Info";
  visible?: boolean;
  children?: any;
}

const sizeStyles = css<{ customSize?: "XLarge" | "Large" }>`
  ${(props) =>
    props.customSize === "XLarge" &&
    css`
      font-size: 14px;
      line-height: 180%; /* 25.2px */
    `}
  ${(props) =>
    props.customSize === "Large" &&
    css`
      font-size: 12px;
      line-height: 180%; /* 21.6px */
    `}
`;

const statusStyles = css<{
  status?: "Default" | "Error" | "Warning" | "Info";
}>`
  ${(props) =>
    props.status === "Default" &&
    css`
      background: var(--Gray--50, ${ColorPalette.gray[50]});
      color: ${ColorPalette.gray[800]};
    `}
  ${(props) =>
    props.status === "Error" &&
    css`
      background: var(--Red--100, ${ColorPalette.red[100]});
      color: ${ColorPalette.red[300]};
    `}

    ${(props) =>
    props.status === "Warning" &&
    css`
      background: var(--Yellow--100, ${ColorPalette.yellow[100]});
      color: ${ColorPalette.yellow[300]};
    `}

      ${(props) =>
    props.status === "Info" &&
    css`
      background: var(--Praimary-Blue-50, ${ColorPalette.primaryBlue[50]});
      color: ${ColorPalette.primaryBlue[700]};
    `}
`;

const StyledHintInput = styled(Typography)<{
  customSize?: "XLarge" | "Large";
  status?: "Default" | "Error" | "Warning" | "Info";
  visible?: boolean;
}>`
  text-align: right;
  font-family: "YekanBakhVF";
  font-style: normal;
  font-weight: 325;
  text-transform: capitalize;
  border-radius: 6px;
  display: inline-flex;
  padding: 4px;
  justify-children: flex-end;
  align-items: flex-start;

  ${sizeStyles}
  ${statusStyles}
 ${(props) =>
    props.visible === false &&
    css`
      visibility: hidden;
    `}
  .
`;

const HintInput: React.FC<CustomHintInput> = ({
  customSize,
  status,
  visible = true,
  children,
  ...props
}) => {
  return (
    <StyledHintInput
      {...props}
      customSize={customSize}
      status={status}
      visible={visible}
    >
      {children}
    </StyledHintInput>
  );
};

export default HintInput;
